import { RefreshTokenStorageService, TokenStorageService } from '@aionzdev/design-system';
import { AuthToken } from '@aionzdev/modules';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenService {
  private authToken$: BehaviorSubject<AuthToken> = new BehaviorSubject<AuthToken>(new AuthToken());

  constructor(
    private _tokenStorage: TokenStorageService,
    private _refreshTokenStorage: RefreshTokenStorageService
  ) {
    this.publishStoredToken();
  }

  authTokenChange(): Observable<AuthToken | null> {
    return this.authToken$.pipe(share());
  }

  set(authToken: AuthToken): Observable<null> {
    this._tokenStorage.set(authToken.token);
    this._refreshTokenStorage.set(authToken.refreshToken);

    this.publishStoredToken();
    return of(null);
  }

  get(): Observable<AuthToken> {
    return of(this.authToken$.getValue());
  }

  clear(): Observable<null> {
    this._tokenStorage.clear();
    this._refreshTokenStorage.clear();

    this.publishStoredToken();
    return of(null);
  }

  private publishStoredToken() {
    this.authToken$.next(
      new AuthToken({
        token: this._tokenStorage.get(),
        refreshToken: this._refreshTokenStorage.get()
      })
    );
  }
}
